import config from '../data/config.json';
import dict from '../data/dictionary.json';

import Mustache from 'mustache';
import L from 'leaflet';

import { Sesion, Datos, Layers } from '../main.js';
import { getMoreSpecificTaxon, getTaxonLabel } from './taxons.js';
import { popupParcela } from './plots.js';
import { getIconoArbol } from './icons.js';
import { getLiteral, getDate, applyPrefix, uriToLiteral, firstUppercase } from './util.js';
import { treePopupTemplate } from '../data/htmlTemplates.js';

function ajustarColorArboles(puris) {
	for (let puri of puris) {
		if (Sesion.parcarbPintadas[puri]) {
			// ajusto iconos de los árboles de la parcela
			for (let arburi of Datos.parcelas[puri].arbs) {
				const aicon = getIconoArbol(Datos.arboles[arburi]);
				if (Sesion.arbPintados[arburi] && Sesion.arbPintados[arburi].getIcon() != aicon)
					Sesion.arbPintados[arburi].setIcon(aicon);
			}
		}
	}
}

function ajustarPopupsArboles(puris) {
	for (let puri of puris) {
		if (Sesion.parcarbPintadas[puri]) {
			// ajusto popups de los círculos
			const texto = popupParcela(Datos.parcelas[puri]);
			for (let circ of Sesion.parcarbPintadas[puri])
				circ.bindPopup(texto);
			// ajusto popups de los árboles de la parcela
			for (let arburi of Datos.parcelas[puri].arbs)  {
				if (Sesion.arbPintados[arburi])
					Sesion.arbPintados[arburi].bindPopup(popupArbol(Datos.arboles[arburi]));
			}
		}
	}
}

// ÁRBOLES
function pintarArboles(puris) {
	// obtenemos las parcelas a pintar
	let parcpintar = [];
	for (let puri of puris) {
		// sólo pintamos si no estaba la parcela en la capa
		if (!Sesion.parcarbPintadas[puri]) {
			// guardo la parcela en la lista
			parcpintar.push(Datos.parcelas[puri]);
			// y añado también a la lista de parcelas pintadas
			Sesion.parcarbPintadas[puri] = []; // array para guardar los círculos de las parcelas
		}
	}
	//console.log("# DE PARCELAS POR PINTAR: "+plots.length);
	// logging del rendering
	//console.log("Rendering de parcelas de árboles: " + _.keys(Sesion.parcarbPintadas).length + " pintadas - " + plots.length +" pendientes");

	// pinto los 4 círculos de las parcelas: 5, 10, 15, 25m
	const imax = config.colores[config.colcircplotind].length - 1;
	for (let plot of parcpintar) {	
		// obtengo texto del popup de la parcela		
		const texto = popupParcela(plot);
		// creo los 4 círculos y les incluyo un popup con el texto anterior
		const opacint = Sesion.estado.mapType === config.mapConfig.mapType[0]? 0.5 : 0.2;
		const opacext = Sesion.estado.mapType === config.mapConfig.mapType[0]? 0.3 : 0.1;		
		Sesion.parcarbPintadas[plot.iri].push( L.circle([plot.lat, plot.lng], 
				{color: config.colores[config.colcircplotind][imax-6], weight: 1, radius: config.radioParcelaN3, fillOpacity: opacint})
			.bindPopup(texto, {maxWidth: 800})
			.addTo(Layers.arbs) );
		Sesion.parcarbPintadas[plot.iri].push( L.circle([plot.lat, plot.lng], 
				{color: config.colores[config.colcircplotind][imax-4], weight: 1, radius: config.radioParcelaN2, fillOpacity: opacext})
			.bindPopup(texto, {maxWidth: 800})
			.addTo(Layers.arbs) );
		Sesion.parcarbPintadas[plot.iri].push( L.circle([plot.lat, plot.lng], 
				{color: config.colores[config.colcircplotind][imax-2], weight: 1, radius: config.radioParcelaN1, fillOpacity: opacext})
			.bindPopup(texto, {maxWidth: 800})
			.addTo(Layers.arbs) );
		Sesion.parcarbPintadas[plot.iri].push( L.circle([plot.lat, plot.lng], 
				{color: config.colores[config.colcircplotind][imax], weight: 1, radius: config.radioParcelaN0, fillOpacity: opacext})
			.bindPopup(texto, {maxWidth: 800})
			.addTo(Layers.arbs) );

		// recorro los árboles de la parcela
		for (let arburi of plot.arbs) {
			// recupero el árbol
			const arb = Datos.arboles[arburi];
			// sólo lo pinto si tiene posición y altura mayor que 0
			if (arb.lat && arb.lng && arb.heightM > 0) {	
				// obtengo su icono
				const ticon = getIconoArbol(arb);
				// pinto y guardo el marcador del árbol
				Sesion.arbPintados[arburi] = L.marker([arb.lat, arb.lng], {icon: ticon})
					.bindPopup(popupArbol(arb))
					.addTo(Layers.arbs);
			}
		}
	}
	return parcpintar.length; // devuelvo parcelas con árboles pintadas
}
function popupArbol(arb) {	
	// preparo plantilla para el mustache
	let arbtemp = {};
	// nombre árbol
	//arbtemp.tree = getLiteral(dict.tree) + " " + applyPrefix(arb.iri, config.prefixes);
	arbtemp.tree = getLiteral(dict.tree) + " " + uriToLiteral(arb.iri, "tree-");
	// extraigo versión ifn
	const ifn = Datos.parcelas[arb.plot].ifn;
	// fuente
	arbtemp.source = getLiteral(dict["source"+ifn]);	
	
	// encabezado (versiones IFN)
	arbtemp.head = [];
	arbtemp.head.push('<th scope="col">'+getLiteral(dict.source)+'</th>');

	// datos de la tabla
	arbtemp.rows = [];

	let ifnvers = []; // versiones ifn a incluir
	let arbvers = {}; // árboles a tratar
	// en este bucle obtengo infvers y arbvers. Además, preparo el encabezado de la tabla (puede que no la haya)
	for (let ifnev of config.ifnVersions) {
		if (ifn === ifnev) {
			ifnvers.push(ifnev);
			arbvers[ifnev] = arb;
		}
		else if (arb["tree"+ifnev] && Datos.arboles[arb["tree"+ifnev]]) {
			ifnvers.push(ifnev);
			arbvers[ifnev] = Datos.arboles[arb["tree"+ifnev]];
		}
		// encabezado tabla...
		if (arbvers[ifnev])
			arbtemp.head.push( '<th scope="col" class="text-end">' + getLiteral(dict["url"+ifnev]) + '</th>' );
	}
	// si sólo hay datos de una versión no pongo tabla
	if (ifnvers.length == 1)
		arbtemp.notabla = true;
	
	// id del árbol
	let row = {};
	if (ifnvers.length > 1) {
		row.head = getLiteral(dict.treemin);
		row.els = [];
		for (let ifnev of ifnvers) 
			row.els.push(uriToLiteral(arbvers[ifnev].iri, "tree-"));
		arbtemp.rows.push(row);
	}

	// dataCapture
	// antes lo cogía de la parcela, el problema es si se refiere a una parcela de otro inventario (que igual no está...)
	row = {};
	row.head = getLiteral(dict.plotDate);
	row.els = [];
	let hayalgo = false;
	for (let ifnev of ifnvers) {
		//let dclab = getDate(Datos.parcelas[arbvers[ifnev].plot].dataCapture);
		let dclab = getDate(arbvers[ifnev].dataCapture);		
		if (dclab)
			hayalgo = true;
		else
			dclab = '';
		row.els.push(dclab);
	}
	if (hayalgo) {
		if (ifnvers.length > 1)
			arbtemp.rows.push(row);
		else
			arbtemp.dataCapture = getLiteral(dict.dataCapture) + " " + row.els[0];
	}
		
	// especie
	row = {};
	row.head = getLiteral(dict.speciesmin);
	row.els = [];
	hayalgo = false;
	for (let ifnev of ifnvers) {
		let nesp = '';
		const txuri = getMoreSpecificTaxon(arbvers[ifnev].species);
		if (txuri && Datos.taxones[txuri].vulgarName)
			nesp = getTaxonLabel(txuri, Sesion.nomci, true);
		if (nesp !== '')
			hayalgo = true;
		row.els.push(nesp);
	}
	if (hayalgo)
		arbtemp.rows.push(row);		
		
	// altura
	row = {};
	row.head = getLiteral(dict.height);
	row.els = [];
	hayalgo = false;
	for (let ifnev of ifnvers) {
		let alt = '';
		if (arbvers[ifnev].heightM && arbvers[ifnev].heightM > 0) {
			alt = Number(getLiteral(arbvers[ifnev].heightM)).toFixed(2) + "m";
			hayalgo = true;
		}
		row.els.push(alt);
	}
	if (hayalgo)
		arbtemp.rows.push(row);
	
	// diámetro
	row = {};
	row.head = getLiteral(dict.diameter);
	row.els = [];
	hayalgo = false;
	for (let ifnev of ifnvers) {
		let dbh = '';
		if (arbvers[ifnev].dbh1mm && arbvers[ifnev].dbh2mm) {
			const dbh1 = getLiteral(arbvers[ifnev].dbh1mm);
			const dbh2 = getLiteral(arbvers[ifnev].dbh2mm);
			if (dbh1 && dbh2) { // media aritmética
				dbh = (dbh1 + dbh2)/2 + 'mm';
				hayalgo = true;
			}		
		}
		row.els.push(dbh);
	}
	if (hayalgo)
		arbtemp.rows.push(row);
	
	// obtengo el popup y lo devuelvo
	return Mustache.render(treePopupTemplate, arbtemp);
}
function quitarArboles() {
	console.info("Borrando capa de árboles...");
	// borro la capa de árboles
	Layers.arbs.clearLayers();
	// inicializo la lista de parcelas pintadas en modo árbol
	Sesion.parcarbPintadas = {};
	// inicializo la lista de árboles pintados
	Sesion.arbPintados = {};	
}

export { pintarArboles, ajustarColorArboles, ajustarPopupsArboles, quitarArboles };